/**
 * useAudioStore — Neural audio engine & soundscapes.
 *
 * Storage: 'alphafocus-audio-storage' (Zustand persist middleware, NOT alphafocus_ prefix)
 * Methods: setSoundscape, setEffectLevel, setAdhdMode, setSpatialAudio
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAudioStore = create(
    persist(
        (set) => ({
            enabled: false,
            volume: 0.6,
            soundscape: 'brown-noise',
            effectLevel: 'medium', // 'low' | 'medium' | 'high'
            adhdMode: false,
            spatialAudio: true,

            setEnabled: (enabled) => set({ enabled }),
            toggleEnabled: () => set((state) => ({ enabled: !state.enabled })),
            setVolume: (volume) => set({ volume }),
            setSoundscape: (soundscape) => set({ soundscape }),
            setEffectLevel: (effectLevel) => {
                set((state) => {
                    // Turn off ADHD mode if effect level is dropped below high
                    if (effectLevel !== 'high' && state.adhdMode) {
                        return { effectLevel, adhdMode: false };
                    }
                    return { effectLevel };
                });
            },
            setAdhdMode: (adhdMode) => {
                set((state) => {
                    // ADHD mode forces high effect level
                    if (adhdMode && state.effectLevel !== 'high') {
                        return { adhdMode, effectLevel: 'high' };
                    }
                    return { adhdMode };
                });
            },
            setSpatialAudio: (spatialAudio) => set({ spatialAudio }),
        }),
        {
            name: 'alphafocus-audio-storage',
            version: 1,
        }
    )
);

export default useAudioStore;
